import React from 'react';

import type { Notification } from '../../../NotificationManager';
import Toast from './components/Toast/Toast';
import { ToastsWrapper } from './Toasts.styled';

export interface ToastsProps {
  className?: string;
  toasts: Notification[];
  onRemove: (id: string) => void;
}

const Toasts = ({ className, toasts, onRemove }: ToastsProps) => {
  const handleHideToast = (id: string) => () => {
    onRemove?.(id);
  };

  return (
    <ToastsWrapper className={className} aria-live="assertive">
      {toasts.map(
        ({ id, message, type, removed, backgroundColor, textColor }: Notification) => (
          <Toast
            key={id}
            text={message}
            type={type}
            dead={removed}
            onHide={handleHideToast(id)}
            backgroundColor={backgroundColor}
            textColor={textColor}
          />
        ),
      )}
    </ToastsWrapper>
  );
};

export default Toasts;
